import React, { PropsWithChildren } from "react";
import { Platform, StyleSheet, View, ViewStyle } from "react-native";
import DropShadow from "react-native-drop-shadow";

const init: ShadowT = {
  x: 0,
  y: 0,
  color: "#dddddd",
  radius: 7,
  opacity: 0.5,
};

interface Props {
  shadow?: ShadowT;
  style?: ViewStyle;
}

const Shadow: React.FC<PropsWithChildren<Props>> = ({ shadow, ...props }) => {
  const styles = StyleSheet.create({
    shadowView: {
      shadowOffset: { width: shadow?.x ?? init.x, height: shadow?.y ?? init.y },
      shadowColor: shadow?.color ?? init.color,
      shadowOpacity: shadow?.opacity ?? init.opacity,
      shadowRadius: shadow?.radius ?? init.radius,
    },
  });

  if (Platform.OS === "web") {
    return (
      <DropShadow style={{ ...styles.shadowView, ...props.style }}>
        {props.children}
      </DropShadow>
    );
  }

  return (
    <DropShadow style={{ ...styles.shadowView }}>
      <View style={props.style}>{props.children}</View>
    </DropShadow>
  );
};

export default Shadow;
